var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 6.67083V2H5.16667V6.67083C4.31289 6.71459 3.50845 7.08431 2.91925 7.70375C2.33005 8.32318 2.00101 9.1451 2 10V18H4.83333V16.6667H3.33333V10C3.33393 9.46975 3.54483 8.96139 3.91978 8.58644C4.29472 8.2115 4.80308 8.0006 5.33333 8H18.6667C19.1969 8.0006 19.7053 8.2115 20.0802 8.58644C20.4552 8.96139 20.6661 9.46975 20.6667 10V16.6667H18.8333V18H22V10C21.999 9.1451 21.67 8.32318 21.0808 7.70375C20.4916 7.08431 19.6871 6.71459 18.8333 6.67083ZM17.5 6.66667H6.5V3.33333H17.5V6.66667Z",
    fill: "#868686"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 9.66667H19.1667V11H17.8333V9.66667ZM4.5 12.3333V13.6667H6.16667V22H17.5V13.6667H19.1667V12.3333H4.5ZM16.1667 20.6667H7.5V13.6667H16.1667V20.6667Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.5368753c03c4981c71a370ac072e3f7d.svg";
export { ForwardRef as ReactComponent };